import { render, staticRenderFns } from "./ssologin.vue?vue&type=template&id=6ee9eee9&scoped=true&"
import script from "./ssologin.vue?vue&type=script&lang=js&"
export * from "./ssologin.vue?vue&type=script&lang=js&"
import style0 from "./ssologin.vue?vue&type=style&index=0&id=6ee9eee9&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9eee9",
  null
  
)

component.options.__file = "ssologin.vue"
export default component.exports